import Vue from 'vue';
import store from '../../store';
import productBasicTransformer from '../../transformers/productBasic';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const products = productBasicTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductsBasic', products);
  resolve(products);
};

const failed = () => {
};

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('products/basic', options))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/allBasic.js